import { formatHoursDurationCompact } from "@src/appV2/redesign/utils/formatHoursDurationCompact";
import { differenceInMilliseconds, differenceInMinutes } from "date-fns";

// keep in mind if you're developing in a browser that you'll be clocked out
// at the 2 hour mark because you're not "inside the geofence"
// the auto clock out job clocks out after 6 hours, but only if you're inside the facility geofence
// so you may want to adjust this locally to e.g. 1 hour in order to not be auto clocked out
const TWO_HOURS_IN_MS = 2 * 60 * 60 * 1000;

export const SHIFT_OVERTIME_THRESHOLD_MS = TWO_HOURS_IN_MS;
export const SHIFT_OVERTIME_THRESHOLD_TEXT = "two hours";

export function getOvertimeInfo(params: { clockInDate: Date; shiftEndDate: Date; now: Date }) {
  const { clockInDate, shiftEndDate, now } = params;
  const overtimeElapsed = differenceInMilliseconds(now, shiftEndDate);
  let progress = 1;
  let overtimeText = "";
  let totalTimeWorked = "";
  const secondaryProgress = 1;

  // Progress is still based on the 2-hour window for the circle, but text is always true overtime
  if (overtimeElapsed <= TWO_HOURS_IN_MS) {
    progress = overtimeElapsed / TWO_HOURS_IN_MS;
  }

  const overtimeDurationInHours = differenceInMinutes(now, shiftEndDate) / 60;
  overtimeText = `+${formatHoursDurationCompact(overtimeDurationInHours, {
    areLeadingZeroesAllowed: false,
  })}`;

  const totalWorkedDurationInHours = differenceInMinutes(now, clockInDate) / 60;
  totalTimeWorked = `${formatHoursDurationCompact(totalWorkedDurationInHours, {
    areLeadingZeroesAllowed: false,
  })} total worked`;

  return { progress, overtimeText, totalTimeWorked, secondaryProgress };
}
